import './OrganizationUnits.scss';
import React from "react";
import {GridReactContextProvider} from "../../../Utils/DataGridWrapper/GridContext";
import {OrganizationUnitTable} from "./OrganizationUnitTable/OrganizationUnitTable";

export const OrganizationUnits = () => {

    return <div className="OrganizationalUnits">
        <GridReactContextProvider>
            <div className="organizationalUnits">
                <OrganizationUnitTable/>
            </div>
        </GridReactContextProvider>
    </div>
}